import { GripVertical } from 'lucide-react'
import { Button } from '@/components/ui/button'
import type { DragHandleBindings } from '@/hooks/use-ogsm-sortable'
import { cn } from '@/lib/utils'

export interface DragHandleProps {
  bindings: DragHandleBindings
  /** aria-label: OGSM_COPY.reorder.handleLabel(title) */
  label: string
  /** title tooltip: objectivesHint or strategiesHint */
  hint: string
  tone: 'band' | 'row'
}

/** The only place a band or row drag starts, so its editors and popovers keep their clicks. */
export function DragHandle({
  bindings: { ref, attributes, listeners },
  label,
  hint,
  tone,
}: DragHandleProps) {
  return (
    <Button
      ref={ref}
      type="button"
      variant="ghost"
      size="icon-xs"
      {...attributes}
      {...listeners}
      aria-label={label}
      title={hint}
      className={cn(
        'cursor-grab touch-none hover:text-primary active:cursor-grabbing',
        tone === 'band' ? 'text-primary/45 [&_svg]:size-3.5' : 'text-primary/20'
      )}
    >
      <GripVertical />
    </Button>
  )
}
